import { useCallback, useLayoutEffect, useRef } from 'react';

const useResizeObserver = <T extends HTMLElement = HTMLElement>(
  callback: (element: T, entries: ResizeObserverEntry[]) => void
) => {
  const ref = useRef<T>(null);
  const handleResize = useCallback(
    (element: T, entries: ResizeObserverEntry[]) => {
      callback(element, entries);
    },
    [callback]
  );

  useLayoutEffect(() => {
    if (!ref.current) {
      return;
    }

    const resizeObserver = new ResizeObserver(entries => {
      if (ref.current) {
        handleResize(ref.current, entries);
      }
    });

    resizeObserver.observe(ref.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [handleResize]);

  return ref;
};

export default useResizeObserver;
